import { render, staticRenderFns } from "./TheSidebarNavDesktop.vue?vue&type=template&id=6a2c38a6&"
import script from "./TheSidebarNavDesktop.vue?vue&type=script&lang=ts&"
export * from "./TheSidebarNavDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports